import { Component, ViewChild } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { AngularFirestore } from 'angularfire2/firestore';
//import { map } from 'rxjs/operators';
import { UsersService } from '../../models/usuarios.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MessagingService } from '../../comum/services/push-notification-service';
import { MatSnackBar } from '@angular/material';
import { NotificationsService } from 'angular2-notifications'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})



export class AppComponent {

  public settings: Settings;
  message;

  routeSemLogin = ['/resetSenha'];



  constructor(private db: AngularFirestore,
    public snackBar: MatSnackBar,
    private router: Router,
    //private activatedRoute: ActivatedRoute,
    public appSettings: AppSettings,
    private authService: UsersService,
    private msgService: MessagingService,
    private _pushNotifications: NotificationsService){
    
    this.settings = this.appSettings.settings;

    let achei = this.routeSemLogin.indexOf(location.pathname);
    console.log(window.location.hostname);
    if (achei<0  )  //&& window.location.hostname!='localhost' 
       router.navigate(['/login'])
  }


  ngOnInit() {
    this.authService.initAuthListener();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.message = this.msgService.currentMessage;
    this.msgService.currentMessage.subscribe(msg=>{
     if (msg){
      this._pushNotifications.create(
        'Mensagem',msg.notification
      );
       console.log(msg);
       const notf = msg.notification;
       this.snackBar.open(notf.title+'<br>'+notf.body,'',{duration:5000});
      }
    });
  }


  public routerActivate(event, outlet) {
  }


  test() {

  }

}